import { PdfGen, PdfUnit, PdfSize, PdfRect, PdfPoint, PdfBrush, ETextAlign } from '../../pdf/pdf';
import { ILayoutImageGen } from '../layoutImage';
import { IItemCount } from '@educraft/base';
import { OptsImage } from '../optsImage';
import { GUtil } from '../../pdf/gutil';
import '../../pdf/draw/primitives';
import '../../pdf/draw/string';
import '../../pdf/draw/image';

/**
 * Skladacka (Puzzle Assembly) - Multiplication strip puzzles
 *
 * Layout: 2 landscape pages, 5 vertical strips each.
 * Each strip: top half image, bottom half image, middle 10 multiplication rows.
 *
 * Migrated from C# EduFrame.Img10.Generators.Skladacka
 */
export class Skladacka implements ILayoutImageGen, IItemCount {
  countDefault(): number {
    return 10;
  }
  countMin(): number {
    return 10;
  }
  countMax(): number {
    return 10;
  }
  public async generate(pdf: PdfGen, opts: OptsImage): Promise<void> {
    const margin = PdfUnit.FromMillimeters(5);

    for (let page = 0; page < 2; page++) {
      const pg = pdf.addPage(true); // landscape

      for (let x = 0; x < 5; x++) {
        const index = page * 5 + x;
        if (index >= opts.list.length) continue;

        const rect = new PdfRect(
          (x * PdfSize.A4.height) / 5,
          0,
          PdfSize.A4.height / 5,
          PdfSize.A4.width
        );
        pg.drawRectangle(GUtil.cutPen, null, rect);

        const szW = rect.width - 2 * margin;
        const szH = szW / 2;
        const r1 = new PdfRect(rect.left + margin, rect.top + margin, szW, szH);
        const r2 = new PdfRect(rect.left + margin, rect.bottom - margin - szH, szW, szH);
        const rx = new PdfRect(r1.left, r1.bottom, szW, r2.top - r1.bottom);

        // Draw top half of image
        const imgRect = new PdfRect(r1.left, r1.top, r1.width, r1.width);
        pg.drawImageFit(opts.list[index].image, imgRect);
        pg.drawRectangle(
          null,
          PdfBrush.White,
          new PdfRect(r1.left, r1.bottom, r1.width, r1.height)
        );

        // Draw bottom half of image
        const imgRect2 = new PdfRect(r2.left, r2.top - r2.width / 2, r2.width, r2.width);
        pg.drawImageFit(opts.list[index].image, imgRect2);
        pg.drawRectangle(
          null,
          PdfBrush.White,
          new PdfRect(r2.left, r2.top - r2.width / 2, r2.width, r2.height)
        );

        // Multiplication rows
        for (let i = 0; i < 10; i++) {
          const r = new PdfRect(rx.left, rx.top + (i * rx.height) / 10, rx.width, rx.height / 10);
          pg.drawRectangle(GUtil.foldPen, null, r);
          pg.drawString(
            `${i + 1} × ${page * 5 + x + 1} =   `,
            GUtil.baseFont,
            PdfBrush.Black,
            null,
            r,
            ETextAlign.Center
          );
        }

        pg.drawRectangle(GUtil.basePen, null, r1);
        pg.drawRectangle(GUtil.basePen, null, r2);
      }
    }
  }
}
